export { default } from './FeeProviderLocationTable';
export { default as LocationTableWrapper } from './LocationTableWrapper';
